export function getCentAmount(price) {
  if (price) {
    if (typeof price !== "string") {
      return price.toString().slice(-2);
    }
    return price.slice(-2);
  }
  return null;
}
